// Global imports for all views using default layout

// Global Styles
import '../../styles/theme.css'

// Global Sections
import '../sections/header'

// External
import { load } from '@shopify/theme-sections'
import { listen } from 'quicklink'
import 'regenerator-runtime/runtime'
import 'lazysizes'
import 'lazysizes/plugins/object-fit/ls.object-fit'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes/plugins/rias/ls.rias'
import 'lazysizes/plugins/bgset/ls.bgset'
import 'lazysizes/plugins/respimg/ls.respimg'

// Internal

import cookiesEnabled from '../core/check-cookies'
import animations from '../core/animations'

window.STOREFRONT_ACCESS_TOKEN = '772b72b61f887ec98b0fafdc2ae81470'
window.GraphQLEndpoint = `/api/2022-10/graphql`

document.addEventListener("DOMContentLoaded", function(event) {
  load('*');

  animations({
    reset: true,
    threshold: .1
  })


  // Apply a specific class to the html element for browser support of cookies.
  if (cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies',
    );
  }

  listen({
    ignores: [
      /\/cart\/?/,
      /\/account\/?/,
      uri => uri.includes('#')
    ]
  })

});
